import rootConfig from "./rootConfig";
import users from "drupal-vuejs/src/App/users/user.js";
export default {
  ...users,
  ...rootConfig,
};
